import { SHOW_ORDER_DIALOG, FETCH_ALL_ORDERS, FETCH_USER_ORDERS, ORDER_COMMITED, FETCH_USER_HISTORY_ORDERS, FETCH_ALL_HISTORY_ORDERS } from "../actions/types";

const commitedOrderData =  (state = null, action) => {
  switch (action.type) {
    case ORDER_COMMITED:
      return action.payload || null;
    default:
      return state;
  }
};

const orderDialog =  (state = false, action) => {
  switch (action.type) {
    case SHOW_ORDER_DIALOG:
      return action.isActive;
    default:
      return state;
  }
};

const ordersData =  (state = "loading", action) => {
  switch (action.type) {
    case FETCH_ALL_ORDERS:

      return action.payload;
    case FETCH_USER_ORDERS:
      if(state !== "loading" && state && action.payload){
        state = {...state, ...action.payload}
      }
      return action.payload;
    default:
      return state;
  }
};

const ordersHistoryData = (state = "loading", action) => {
  switch (action.type) {
    case FETCH_USER_HISTORY_ORDERS:
      if(state !== "loading" && state && action.payload){
        return {...state, [action.uid]: action.payload}
      }else return {[action.uid]: action.payload};
    case FETCH_ALL_HISTORY_ORDERS:
      return action.payload;
    default:
      return state;
  }
};


export default {
  orderDialog,
  ordersData,
  commitedOrderData,
  ordersHistoryData
}



// WEBPACK FOOTER //
// ./src/reducers/ordersReducer.js